module.exports = __webpack_public_path__ + "static/media/fb.7143fe9a.svg";